import React from 'react';
import { useParams } from 'react-router-dom';
import { Grid, makeStyles, Typography } from 'housecall-ui';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

import { CompanyLogo } from '../components/CompanyLogo';
import { useOrgData } from '../hooks/useOrgData';
import { useOnlineBookingReducer } from '../state/useOnlineBookingReducer';

const useStyles = makeStyles((theme: HCPTheme) => ({
  container: {
    marginTop: theme.spacing(2),
    height: '100%',
    width: '100%',
    justifyContent: 'center',
  },
}));

type Props = {
  customerBanned?: boolean;
};

export const OnlineBookingUnavailable = ({ customerBanned = false }: Props) => {
  const { state } = useOnlineBookingReducer();
  const { orgName } = useParams<{ orgName?: string }>();

  const { container } = useStyles();

  const { token } = state;

  const { data: orgData } = useOrgData({ token });

  const displayedName = orgName || 'our online booking';
  const phoneNumber = orgData?.phoneNumber;

  return (
    <>
      <CompanyLogo />
      <Grid container alignItems="center" className={container}>
        <Grid item>
          {customerBanned ? null : (
            <Typography gutterBottom variant="h5" align="center">
              Welcome to {displayedName}
            </Typography>
          )}
          <Typography variant="body1" align="center" data-testid="unavailable-info">
            Unfortunately online booking is currently <b>unavailable</b>. <br />
            {customerBanned ? null : (
              <>
                Please call <b>{phoneNumber}</b> to contact us.
              </>
            )}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
